



























import Vue from "vue";
import BaseIcon from "@/components/BaseIcon";
import BaseMenu from "@/components/BaseMenu";
import BaseTitle from "@/components/BaseTitle";
import GoBack from "@/components/GoBack";

Vue.component("BaseTitle", BaseTitle);
Vue.component("BaseIcon", BaseIcon);
Vue.component("BaseMenu", BaseMenu);
Vue.component("GoBack", GoBack);

export default Vue.extend({
  name: "PageTitle",
  props: {
    hideBack: { type: Boolean, default: false },
    icon: { type: String, default: "sci-back" },
    pageMenu: { type: Boolean, default: false },
    defaultBack: { type: Object },
    transparent: { type: Boolean, default: false },
  },
});
